export default __webpack_public_path__ + "src/images/packages/unembeza-boutique-lodge/58e59ebfbdee184b3f73815e30fa21ec-1.png";